import { Button, ContentTemplate, SectionHeader } from 'web-library';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import ImportantNotesContent from '../../../modules/accessArrangment/components/candidate/ImportantNotes/ImportantNotesContent';
import key from '../../../routes/key';
import PendingApplicationDetails from '../../../modules/accessArrangment/components/candidate/ImportantNotes/PendingApplicationDetails';
import LateApplicationDialog from '../../../modules/accessArrangment/components/candidate/ImportantNotes/LateApplicationDialog';
import { candidateService } from '../../../api';
import { usePostTransactionLog } from '../../../api-refactored/candidate/usePostTransactionLog';
import { useWOGAA } from '../../../hooks/wogaa';

const { accessArrangement } = key.child;
const { coordinatorRoot, coordinatorSelectCandidate, coordinatorSelectCondition } = key[
  'access-arrangement'
].child;

const ImportantNotesCoordinator = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { t } = useTranslation();
  const history = useHistory();

  const [draftData, setDraftData] = useState<any>([]);

  const draftDataMutate = candidateService.accessArrangement.candidate.usePostAppealArrangementDraft(
    (res) => {
      setDraftData(res.data);
    },
    () => {
      // do nothing
    }
  );

  const { mutate: apiMutate } = usePostTransactionLog();

// wogaa tracking start for AA application by coordinator
  const { transactionStart } = useWOGAA('myexamsseab-6467');

  useEffect(() => {
    /**
     * localStorage to get uuid from coordinator Select Condition page
     */
    if (localStorage.getItem('uuid')) {
      const uuid = localStorage.getItem('uuid') || '';
      draftDataMutate.mutate({ uuid });
      localStorage.removeItem('uuid');
    } else {
      draftDataMutate.mutate({});
    }
    /*  eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  const lateApplication = false;
  const pendingApplication = useMemo(() => !!draftData?.uuid, [draftData]);

  const handleStartApplication = () => {
    transactionStart();
    if (draftData?.uuid) {
      apiMutate({
        auditActionType: 'CONTINUE_ACCESS_ARRANGEMENT_REQUEST',
        applicationId: draftData.applicationNo,
      });
    }
    if (pendingApplication) {
      history.push(
        `/${accessArrangement}/${coordinatorRoot.route}/${coordinatorSelectCondition.route}/${draftData.uuid}`
      );
    } else {
      history.push(
        `/${accessArrangement}/${coordinatorRoot.route}/${coordinatorSelectCandidate.route}`
      );
    }
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  return (
    <>
      <ImportantNotesContent />
      <ContentTemplate continuous>
        <SectionHeader title={t('accessArrangement->>Notes.GetStarted')} />
        {pendingApplication && draftData && (
          <PendingApplicationDetails
            applicationNo={draftData.applicationNo}
            examLevel={draftData.examLevels.length === 0 ? '-' : draftData.examLevels.join(', ')}
          />
        )}
        <Button
          id="button-start-application"
          onClick={lateApplication ? handleOpenDialog : handleStartApplication}
        >
          {pendingApplication
            ? t('accessArrangement->>Notes.ContinueApplication')
            : t('accessArrangement->>Notes.StartApplication')}
        </Button>
      </ContentTemplate>
      <LateApplicationDialog
        onProceed={handleStartApplication}
        onCancel={handleCloseDialog}
        open={dialogOpen}
      />
    </>
  );
};

export default ImportantNotesCoordinator;
